import { writable } from "svelte/store";
export const user = writable({ loggedIn: false, email: "", uid: "" });
